module.exports = __webpack_public_path__ + "img/home_tp_icon.282f67c.png";